import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromRoles from './+state/roles/roles.reducer';
import { EffectsModule } from '@ngrx/effects';
import { RolesEffects } from './+state/roles/roles.effects';
import { RolesFacade } from '@boma/supplier-portal/users';
import { UiModule } from '@boma/ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IndexComponent } from './containers/roles/index/index.component';
import { RouterModule } from '@angular/router';
import * as fromPermissions from './+state/permissions/permissions.reducer';
import { PermissionsEffects } from './+state/permissions/permissions.effects';
import { PermissionsFacade } from './+state/permissions/permissions.facade';
import { EntityResolver } from '@boma/supplier-portal/shared/services';

const router = RouterModule.forChild([
  {
    path: ':entityId',
    pathMatch: 'full',
    component: IndexComponent,
    resolve: {
      entityData: EntityResolver,
    },
  },
]);

@NgModule({
  declarations: [IndexComponent],
  imports: [
    CommonModule,
    UiModule,
    router,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromRoles.ROLES_FEATURE_KEY, fromRoles.roleReducer),
    StoreModule.forFeature(
      fromPermissions.permissionsFeatureKey,
      fromPermissions.reducer
    ),
    EffectsModule.forFeature([PermissionsEffects, RolesEffects]),
  ],
  providers: [RolesFacade, PermissionsFacade],
})
export class SupplierPortalRolesModule {}
